export const FETCH_PATIENTS_SUCCESS = 'FETCH_PATIENTS_SUCCESS'
export const FETCH_PATIENTS_FAILURE = 'FETCH_PATIENTS_FAILURE'



